import { Resource } from '../../../__generated__/graphql';

type AGResource = Pick<Resource, 'name' | 'type'>;

export default function getRoomNumber(resources: AGResource[]): string | undefined {
  return resources?.find((resource) => resource.type === 'LOCK')?.name;
}
